/**
 * Canonical display labels for the dev role override system (spec 0111).
 *
 * Single source of truth for value → label mappings used by DevSettingsModal
 * and TopBar. Add new levels/roles here; consumers update automatically.
 */

import type { DevAssumedLevel, DevAssumedRole } from '@/hooks/useDevRoleOverride';

export const LEVEL_LABELS: Record<DevAssumedLevel, string> = {
  none: 'Consultant',
  lead: 'Senior Consultant / Lead',
  manager: 'Manager',
  director: 'Director',
  vp: 'VP / SVP / C-Suite',
};

export const ROLE_LABELS: Record<DevAssumedRole, string> = {
  none: 'Delivery',
  pm: 'Product Management',
  project_management: 'Project Management',
  client_management: 'Client Management',
  fullstack: 'Technology / Full Stack',
  de: 'Data Engineering',
  ds: 'Data Science',
  ai: 'AI Engineering',
};

/** Ordered option list for the Level <Select> in DevSettingsModal. */
export const LEVEL_OPTIONS: { value: DevAssumedLevel; label: string }[] = [
  { value: 'none', label: LEVEL_LABELS.none },
  { value: 'lead', label: LEVEL_LABELS.lead },
  { value: 'manager', label: LEVEL_LABELS.manager },
  { value: 'director', label: LEVEL_LABELS.director },
  { value: 'vp', label: LEVEL_LABELS.vp },
];

/** Ordered option list for the Functional Group <Select> in DevSettingsModal. */
export const ROLE_OPTIONS: { value: DevAssumedRole; label: string }[] = [
  { value: 'none', label: ROLE_LABELS.none },
  { value: 'pm', label: ROLE_LABELS.pm },
  { value: 'project_management', label: ROLE_LABELS.project_management },
  { value: 'client_management', label: ROLE_LABELS.client_management },
  { value: 'fullstack', label: ROLE_LABELS.fullstack },
  { value: 'de', label: ROLE_LABELS.de },
  { value: 'ds', label: ROLE_LABELS.ds },
  { value: 'ai', label: ROLE_LABELS.ai },
];
